import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import findFolderOperation from 'owa-service/lib/operation/findFolderOperation';
import findFolderRequest from 'owa-service/lib/factory/findFolderRequest';
import folderId from 'owa-service/lib/factory/folderId';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { PublicFolderRequestInit } from 'owa-public-folder-favorite';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import propertyUri from 'owa-service/lib/factory/propertyUri';

export default function findPublicFolders(
    rootFolderId: string
): Promise<FindFolderResponseMessage> {
    const defaultAnchorMailbox = getUserConfiguration().SessionSettings.DefaultPublicFolderMailbox;
    if (!defaultAnchorMailbox) {
        return null;
    }

    return findFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: findFolderRequest({
                FolderShape: folderResponseShape({
                    BaseShape: 'IdOnly',
                    AdditionalProperties: [propertyUri({ FieldURI: 'ReplicaList' })],
                }),
                Paging: null,
                ParentFolderIds: [
                    rootFolderId == 'publicfoldersroot'
                        ? distinguishedFolderId({ Id: rootFolderId })
                        : folderId({ Id: rootFolderId }),
                ],
                ReturnParentFolder: true,
                ShapeName: 'Folder',
                Traversal: 'Shallow',
            }),
        },
        PublicFolderRequestInit(defaultAnchorMailbox)
    )
        .then(response => {
            const findFolderResponse = response.Body.ResponseMessages.Items[0];
            return findFolderResponse;
        })
        .catch(() => {
            return null;
        });
}
